export default __webpack_public_path__ + "static/media/9.edf4c7b5.png";